import { render, staticRenderFns } from "./Valves.vue?vue&type=template&id=3457c93b&scoped=true"
import script from "./Valves.vue?vue&type=script&lang=js"
export * from "./Valves.vue?vue&type=script&lang=js"
import style0 from "./Valves.vue?vue&type=style&index=0&id=3457c93b&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3457c93b",
  null
  
)

export default component.exports